import { OPERATORS } from '../../constants';
import { BaseOperatorStrategy } from './base.operator-strategy';
import type {
  SelectionBlockerArgs,
  SelectionBlockerResult,
} from '../operator-strategy';

/**
 * AISstream pricing & constraint strategy.
 *
 * - Cost model: time-window subscription (cost is pre-computed on sensorRow from backend)
 * - Constraints: open-water areas only
 *
 * Register in OperatorStrategyFactory.getStrategy() under OPERATORS.AISSTREAM.
 */
export class AisstreamOperatorStrategy extends BaseOperatorStrategy {
  readonly operatorKey = OPERATORS.AISSTREAM;

  protected computeBaseCost(sensorRow: any, _latencyIndx: number): number | null {
    // AISstream is a flat time-window subscription — return the preset unit cost directly.
    return sensorRow?.unitcost ?? 0;
  }

  getSelectionBlocker(args: SelectionBlockerArgs): SelectionBlockerResult | null {
    if (!args.taskingContext) return null;
    // AIS data only exists over open water
    if (args.sensorRow?.openWater === false) {
      return {
        code:    'AISSTREAM_LAND_TARGET',
        message: 'AISstream vessel tracking is only available for open-water areas. Please select a maritime region.',
      };
    }
    return null;
  }
}
